import React, { useMemo } from 'react';
import { Box } from 'braid-design-system';
import { CarouselItem } from './CarouselItem';
import { mobileScrollContainer, mobileScrollItem } from '../Carousel.css';
import type { CarouselItem as CarouselItemType } from '../utils/carouselUtils';

interface MobileScrollViewProps {
  items: CarouselItemType[];
}

export const MobileScrollView = React.memo<MobileScrollViewProps>(
  ({ items }) => {
    const itemsWithKeys = useMemo(
      () =>
        items.map((item, index) => ({
          item,
          key: `item-${index}`,
        })),
      [items],
    );

    return (
      <Box className={mobileScrollContainer}>
        {itemsWithKeys.map(({ item, key: itemKey }) => (
          <Box key={itemKey} className={mobileScrollItem}>
            <CarouselItem item={item} />
          </Box>
        ))}
      </Box>
    );
  },
);

MobileScrollView.displayName = 'MobileScrollView';
